export enum Cookie {
  NUMBER_OF_PRODUCTS = "cartCount",
  CART_ID = "cartId",
  CART_PRODUCTS = "cartProducts",
  CART_URI = "cartUri",
  PAGE_REDIRECTED_FROM = "pageRedirectedFrom",
  GRP = "grp",
  STB_ID = "stb_id",
}
